let $body;
let $hamburger;
let $menuMobile;
let $header;
let $headerHeight;
let $heroSlider;
let $carouselSlider;
let $logoSlider;
let $contentContainer;
let $social;
let $tableOfContents;
let $tabs;
let $tabsContent;
let $toTopButton;
let $toggleAuthorPopup;
let $authorPopup;
let $copyrightBlock;
let $copyrightContent;
let $queryString;
let $readMoreButton;
let $readMoreContainer;
let $observationContainer;
let $addToCalendarSelect;
let $videoBlock;
let $programParts;
let $headerSlider;
let $headerSliderThumbnails;
let $pictureSlider;
let $pictureSliderOverlay;
let $closeOverlay;
let $audioElem;
let $audioPlayer;
let $readMore;
let $readMoreToggle;
let $videoPlayer;
let accordion;
const mainI18n = (typeof window !== 'undefined' && window.novioI18n && window.novioI18n.main)
  ? window.novioI18n.main
  : {};

function mainT(key) {
  return typeof mainI18n[key] === 'string' ? mainI18n[key] : key;
}

$(document).ready(($) => {
  console.log('%cLinku Novio', 'font-size: 2em; font-family: sans-serif; color: white; background-color:#18aaff; padding:4px 8px; border-radius: 4px');

  $body = $('body');
  $hamburger = $('.js-menu-toggle');
  $carouselSlider = $('.js-carousel-slider');
  $header = $('.js-header');
  $menuMobile = $('.js-menu-mobile');
  $heroSlider = $('.js-hero-slider');
  $logoSlider = $('.js-logo-slider');
  $videoBlock = $('.wp-block-video');
  $contentContainer = $('.js-item-content');
  $social = $('.js-social-share');
  $tableOfContents = $('.js-toc');
  $tabs = $('.js-tab');
  $tabsContent = $('.js-tab-content');
  $toTopButton = $('.js-to-top-button');
  $toggleAuthorPopup = $('.js-toggle-author-popup');
  $authorPopup = $('.js-author-popup');
  $copyrightBlock = $('.js-copyright');
  $copyrightContent = $('.js-copyright-content');
  $headerHeight = $header.outerHeight();
  $readMoreButton = $('.js-read-more-button');
  $readMoreContainer = $('.js-read-more-container');
  $observationContainer = $('.js-observation-container');
  $addToCalendarSelect = $('.js-add-to-calendar');
  $programParts = $('.js-program-part');
  $videoPlayer = $('.js-video-detail__video-overlay');
  $headerSlider = $('.js-header-slider');
  $headerSliderThumbnails = $('.js-header-slider-thumbnails');
  $pictureSlider = $('.js-picture-slider');
  $pictureSliderOverlay = $('.js-picture-slider-overlay');
  $closeOverlay = $('.js-close-overlay');
  $audioPlayer = $('.js-audio-player');
  $queryString = window.location.search;
  $readMore = $('.js-read-more');

  if ($queryString == '?open-flipbook') {
    // delay to make sure everything needed is loaded
    setTimeout(() => {
      $('.open-flipbook').trigger('click');
    }, 1000);
  }

  $readMore.each(function () {
    const readMore = $(this);
    const readMoreToggle = readMore.find('.js-read-more-toggle');
    const readMoreContent = readMore.find('.js-read-more-more');

    readMoreToggle.click((e) => {
      e.preventDefault();
      readMore.toggleClass('is-expanded');
      const isExpanded = readMore.hasClass('is-expanded');

      readMoreToggle.attr('aria-expanded', isExpanded);
      if (isExpanded) {
        readMoreToggle.text(readMore.data('read-less-text'));
        readMoreContent.removeClass('rs_skip');
      } else {
        readMoreToggle.text(readMore.data('read-more-text'));
        readMoreContent.addClass('rs_skip');
      }
    });
  });

  $hamburger.on('click', function (e) {
    if ($hamburger.hasClass('is-open')) {
      $(this).removeClass('is-open');
      $body.removeClass('menu-is-open');
      $menuMobile.slideToggle();
    } else {
      $(this).addClass('is-open');
      $menuMobile.slideToggle();
      $body.addClass('menu-is-open');
    }

    $('.js-submenu').removeClass('is-open');
    $('.js-submenu-open').removeClass('is-open');
  });

  $observationContainer.each(function () {
    const readMoreButton = $(this).find('.js-read-more-button');
    const readMoreContainer = $(this).find('.js-read-more-container');
    const observationContent = $(this).find('.js-observation-content');
    addClickReadMore(readMoreButton, readMoreContainer, observationContent);
  });
  $programParts.each(function () {
    const readMoreButton = $(this).find('.js-read-more-button');
    const readMoreContainer = $(this).find('.js-read-more-container');
    const partContent = $(this).find('.js-program-content');
    addClickReadMore(readMoreButton, readMoreContainer, partContent);
  });

  $toTopButton.on('click', () => {
    $('html, body').animate({ scrollTop: 200 }, { duration: 500, queue: false });
  });

  $heroSlider.each((index, value) => {
    const heroSlider = tns({
      container: value,
      items: 1,
      mouseDrag: true,
      speed: 600,
      nav: true,
      navPosition: 'bottom',
      autoplayButton: false,
      autoplayPosition: 'bottom',
      autoplayText: ['<i class="fal fa-play"></i>', '<i class="fal fa-pause"></i>'],
      controlsText: ['<i class="fal fa-chevron-left"></i>', '<i class="fal fa-chevron-right"></i>'],
      controls: true,
      autoplay: true,
      autoHeight: false,
    });
    setLabelsAfterSliderRendered(heroSlider);
  });

  let headerSlider;
  let thumbnailSlider;

  $headerSlider.each((index, value) => {
    headerSlider = tns({
      container: value,
      items: 1,
      mouseDrag: true,
      speed: 600,
      nav: true,
      navPosition: 'bottom',
      autoplayButton: false,
      mode: 'gallery',
      autoplayText: ['', ''],
      controlsText: ['', ''],
      controls: false,
      autoplay: false,
      autoHeight: true,
      center: true,
      loop: true,
      autoplayHoverPause: true,
      navContainer: '.js-header-slider-thumbnails',
    });
    setLabelsAfterSliderRendered(headerSlider);
  });

  $headerSliderThumbnails.each((index, value) => {
    const thumbnailSlider = tns({
      container: value,
      items: 5,
      mouseDrag: true,
      speed: 600,
      nav: false,
      autoplayButton: false,
      autoplayText: ['', ''],
      controlsText: ['', ''],
      controls: true,
      autoplay: false,
      autoHeight: false,
      autoplayHoverPause: true,
      loop: false,
      fixedWidth: 85,
      gutter: 12,
    });
    setLabelsAfterSliderRendered(thumbnailSlider);

    headerSlider.events.on('indexChanged', (evt) => {
      const indexToGoTo = evt.index > headerSlider.getInfo().slideCount ? 0 : evt.index - 1;
      thumbnailSlider.goTo(indexToGoTo);
    });
  });

  let pictureSlider;

  $pictureSlider.each((index, value) => {
    pictureSlider = tns({
      container: value,
      items: 1,
      center: true,
      controlsText: ['<i class="fal fa-arrow-left"></i>', '<i class="fal fa-arrow-right"></i>'],
      nav: false,
      mouseDrag: true,
      loop: false,
      onInit: hideSlideItems,
      gutter: 24,
      navContainer: '.js-picture-slider-overlay',
      responsive: {
        991: {
          gutter: 0,
        },
      },

    });
    setLabelsAfterSliderRendered(pictureSlider);

    // bind function to event
    pictureSlider.events.on('indexChanged', hideSlideItems);
  });

  function hideSlideItems(info, eventName) {
    const containerId = info.container.id;
    const $sliderItems = $(`#${containerId} .tns-item`);
    const $activeSlide = $('.tns-slide-active');

    $sliderItems.addClass('is-hidden');
    $activeSlide.removeClass('is-hidden');
    $activeSlide.prev().removeClass('is-hidden');
    $activeSlide.next().removeClass('is-hidden');
  }

  $pictureSliderOverlay.each((index, value) => {
    const pictureSliderOverlay = tns({
      container: value,
      items: 1,
      center: true,
      controlsText: ['<i class="fal fa-arrow-left"></i>', '<i class="fal fa-arrow-right"></i>'],
      nav: false,
      mouseDrag: true,
      loop: false,
    });
    setLabelsAfterSliderRendered(pictureSliderOverlay);

    pictureSlider.events.on('indexChanged', (evt) => {
      const indexToGoTo = evt.index > pictureSlider.getInfo().slideCount ? 0 : evt.index - 2;
      pictureSliderOverlay.goTo(evt.index);
    });
  });

  $closeOverlay.on('click', () => {
    $('.b-picture-slider__overlay-background').removeClass('is-open');
  });

  $('.js-slide-container').on('click', () => {
    if ($(window).width() > 767) {
      $('.b-picture-slider__overlay-background').addClass('is-open');
    }
  });

  $carouselSlider.each((index, value) => {
    const carouselSlider = tns({
      container: value,
      items: 1,
      mouseDrag: true,
      speed: 1000,
      nav: true,
      navPosition: 'bottom',
      autoplayButton: false,
      autoplayButtonOutput: false,
      autoplayPosition: 'bottom',
      controlsText: ['<i class="fal fa-arrow-left"></i>', '<i class="fal fa-arrow-right"></i>'],
      // controls: true,
      autoplay: false,
      autoHeight: false,
      center: true,
      responsive: {
        992: {
          fixedWidth: 650,
          items: 3,
        },
        1200: {
          fixedWidth: 792,
        },
      },
    });
    setLabelsAfterSliderRendered(carouselSlider);
  });

  $copyrightBlock.each(function () {
    let captionHeight = 0;
    if ($(this).find('figcaption').length !== 0) {
      captionHeight = $(this).find('figcaption').outerHeight() + 6;
    }
    console.log('captionheight ', captionHeight);
    $(this).find('.js-copyright-content').css('bottom', captionHeight);
  });

  $logoSlider.each((index, value) => {
    // $.when(
    const logoSlider = tns({
      container: value,
      items: 2,
      mouseDrag: false,
      speed: 600,
      controlsContainer: '.js-nav-container',
      controlsText: ['', ''],
      controls: true,
      nav: false,
      autoplay: true,
      autoplayButtonOutput: false,
      autoHeight: true,
      center: true,
      responsive: {
        640: {
          items: 3,
        },
        800: {
          items: 4,
        },
        900: {
          items: 6,
        },
        1200: {
          items: 8,
        },
      },
    });

    setLabelsAfterSliderRendered(logoSlider);
  });

  $videoBlock.each(function () {
    console.log($(this).find('video'));
    if ($(this).find('video').attr('autoplay') !== 'autoplay') {
      $(this).addClass('paused');
    }

    const video = $(this).find('video').get(0);
    let playing = false;

    // video.removeAttribute('controls');
    $(this).click(function () {
      if (playing) {
        video.pause();
        $(this).addClass('paused');
      } else {
        video.play();
        $(this).removeClass('paused');
      }
      playing = !playing;
    });
  });

  // Use event delegation to support dynamically added elements
  $(document).on('click', '.js-toggle-author-popup', function (e) {
    e.stopPropagation();
    $('.js-author-popup').each(function () {
      if ($(this).hasClass('show')) {
        $(this).fadeOut().removeClass('show');
      }
    });
    $(this).find('.js-author-popup').fadeIn().addClass('show');
  });

  $videoPlayer.on('click', function () {
    $(this).find('.c-video-detail__video').toggleClass('is-visible');
    $(this).toggleClass('is-hidden');

    const $iframe = $('.c-video-detail__video iframe');
    const videoUrl = $iframe.attr('src');

    if (videoUrl && !videoUrl.includes('autoplay=1')) {
      $iframe.attr('src', `${videoUrl}&autoplay=1`);
    }
  });

  $body.click(() => {
    $authorPopup.fadeOut().removeClass('show');
  });

  $audioPlayer.on('click', function () {
    const player = $(this).find('audio')[0];
    player.paused ? player.play() : player.pause();
  });

  // Gravityforms upload button
  $('.gfield--type-fileupload').each(function () {
    const isPhoto = $(this).hasClass('is-foto');

    const $that = $(this).find('.ginput_container_fileupload:not(:has(> .gform_fileupload_multifile))');

    const inputContainer = $that;
    const currentHtml = $that.html();
    const { lang } = document.documentElement;
    let label = lang === 'en-US' ? 'Upload file' : 'Bestand toevoegen';
    let errorLabel = lang === 'en-US' ? 'You haven\'t added a file yet.' : 'Je hebt nog geen bestand toegevoegd.';

    if (isPhoto) {
      label = lang === 'en-US' ? 'Upload photo' : 'Upload foto';
      errorLabel = lang === 'en-US' ? 'You haven\'t added a photo yet.' : 'Je hebt nog geen foto toegevoegd.';
    }

    const newHtml = `<label class="c-form__file-upload"><i class="fas fa-upload"></i> ${label}${currentHtml}</label><p class="js-upload-text c-form__file-upload-text">${errorLabel}</p>`;
    $that.html(newHtml);
    const currentInput = $(this).find('input[type="file"]');
    currentInput.change(function () {
      inputContainer.find('.js-upload-text').text(this.files[0].name);
    });
  });

  $addToCalendarSelect.change(function () {
    if ($(this).selectedIndex !== 0) {
      window.open($(this).children('option:selected').val(), 'name');
    }
  });
  $('#download-pdf').click(function () {
    console.log('test');
    const fileName = $(this).data('slug');
    const element = document.getElementById('pdfprint');

    const opt = {
      filename: `${fileName}.pdf`,
      margin: [5, 12, 15, -28],
      jsPDF: { unit: 'mm', format: 'A4', orientation: 'portrait' },
      pagebreak: { mode: 'avoid-all', avoid: ['img', '.container--small', '.container'] },
    };
    html2pdf().set(opt).from(element).toPdf()
      .save();
  });

  initTabs();
  handleTabClicks();

  scrollInContainer($toTopButton);
  scrollInContainer($social);

  accordion = new Accordion(
    '.js-accordion',
    '.js-toggle-accordion',
    '.js-accordion-content',
  );

  accordion.initClickHandling();

  $(document).on('click', '.js-read-more-shortcode-btn', function () {
    const $btn = $(this);
    const $content = $btn.closest('.js-read-more-shortcode').find('.js-read-more-shortcode-content');
    const isOpen = $btn.attr('aria-expanded') === 'true';

    if (isOpen) {
      $content.slideUp(() => $content.attr('aria-hidden', 'true'));
      $btn.attr('aria-expanded', 'false');
      $btn.contents().filter(function () { return this.nodeType === 3; }).first().replaceWith($btn.data('labelOpen'));
    } else {
      $content.slideDown(() => $content.attr('aria-hidden', 'false'));
      $btn.attr('aria-expanded', 'true');
      $btn.contents().filter(function () { return this.nodeType === 3; }).first().replaceWith($btn.data('labelClose'));
    }
  });
});

$(window).on('load', () => {
  let ga;
  let height;
  const $ad = $('.js-ad');
  if ($ad.length > 0) {
    $ad.each(function () {
      ga = $(this).find('.js-google-ad');
      height = ga.find('div').height();
      if (!height) {
        height = '0';
        $(this).css('display', 'none');
      }
      if (!$(this).hasClass('js-multiblock')) {
        $(this).height(height);
      }
    });
  }
});

$('.js-audio-controls').on('loadedmetadata', function () {
  const { duration } = $(this)[0];
  const durationString = durationToMinutesSeconds(duration);
  $('.js-audio-duration').text(durationString);
});

function durationToMinutesSeconds(duration) {
  const minutes = Math.floor(duration / 60);
  const seconds = Math.round(duration % 60);
  return (
    seconds === 60
      ? `${minutes + 1}:00`
      : `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`
  );
}

function setLabelsAfterSliderRendered(slider) {
  var sliderRenderedTimeout = window.setInterval(() => {
    const sliderRendered = afterSliderRendered(slider);
    if (sliderRendered) {
      window.clearInterval(sliderRenderedTimeout);
    }
  }, 5);
}

function afterSliderRendered(slider) {
  const sliderInfo = slider.getInfo();
  if (sliderInfo.isOn) {
    setSliderButtonLabels(sliderInfo);
    return true;
  }
  return false;
}

function setSliderButtonLabels(sliderInfo) {
  $(sliderInfo.nextButton).attr('aria-label', 'slide right');
  $(sliderInfo.prevButton).attr('aria-label', 'slide left');
}

function scrollInContainer($item) {
  if (!isMobile() && !isTablet()) {
    $contentContainer.each(function () {
      const currentContainer = $(this);
      const maxHeight = currentContainer.outerHeight() - 200 - $item.outerHeight();

      $(window).scroll(() => {
        const heightDifference = $(window).scrollTop() - currentContainer.offset().top + $headerHeight;

        if (heightDifference > 0 && heightDifference < maxHeight) {
          $item.addClass('fix');
        } else {
          $item.removeClass('fix');
        }
      });
    });
  }
}

function ajax(action, postData, succesCallback, errorCallback) {
  postData = $.extend({}, postData, { action });

  const ajax_url = (typeof linku_ajax_url !== 'undefined') ? linku_ajax_url : '/wp/wp-admin/admin-ajax.php';
  $.ajax({
    type: 'POST',
    url: ajax_url,
    data: postData,
    dataType: 'json',
    success(response) {
      if (response === '0') {
        if (typeof errorCallback === 'function') errorCallback(response);
      } else if (typeof succesCallback === 'function') succesCallback(response);
    },
    error(response) {
      if (typeof errorCallback === 'function') {
        if (typeof response.responseJSON === 'object') {
          errorCallback(response.responseJSON);
        } else if (typeof response.responseText === 'string' && response.responseText !== '') {
          try {
            const jsonErr = JSON.parse(response.responseText);
            errorCallback(jsonErr);
          } catch (e) {
            errorCallback({ message: 'general' });
          }
        } else {
          errorCallback({ message: 'general' });
        }
      }
    },
  });
}

function initTabs() {
  $tabs.each(function () {
    if ($(this).hasClass('is-active')) {
      const tabName = $(this).data('tab-name');
      const $tabContent = $(`[data-tab-content="${tabName}"]`);
      const $tableOfContent = $tabContent.find('.js-toc');

      if ($tableOfContent.length > 0) {
        monitorActiveTocItem($tabContent[0]);
      }
    }
  });
}

function handleTabClicks() {
  const activeClass = 'is-active';

  $tabs.on('click', function (e) {
    const tabName = $(this).data('tab-name');
    const $tabContent = $(`[data-tab-content="${tabName}"]`);
    const $tableOfContent = $tabContent.find('.js-toc');

    $tableOfContents.removeClass(activeClass);
    if ($tableOfContent.length > 0) {
      $tableOfContent.addClass(activeClass);
      monitorActiveTocItem($tabContent[0]);
    }

    $tabs.removeClass(activeClass);
    $tabsContent.removeClass(activeClass);
    $tabContent.addClass(activeClass);
    $(this).addClass(activeClass);
  });
}

function addClickReadMore($readMoreButton, $readMoreButtonContainer, $readMoreContentContainer) {
  $readMoreButton.click(() => {
    // Get translatable strings from data attributes, with fallbacks
    const moreText = $readMoreButton.data('more') || 'Lees meer';
    const lessText = $readMoreButton.data('less') || 'Toon minder';

    if ($readMoreContentContainer.hasClass('limitShow')) { // open
      $readMoreContentContainer.removeClass('limitShow'); // open
      $readMoreButtonContainer.removeClass('open');
      $readMoreButton.text(`${lessText} -`);
    } else {
      $readMoreContentContainer.addClass('limitShow'); // open
      $readMoreButtonContainer.addClass('open');
      $readMoreButton.text(`${moreText} +`);
    }
  });
}

const getAudioDuration = (elem) => new Promise((resolve) => {
  if (elem.readyState >= 1) {
    resolve(elem.duration);
  }
  $audioElem.on('loadedmetadata', () => {
    resolve(elem.duration);
  });
});

$audioElem = $('.js-audio-controls');
$audioElem.each(function () {
  getAudioDuration($(this)[0]).then((duration) => {
    const durationString = durationToMinutesSeconds(duration);
    $(this).siblings('.js-audio-duration').text(durationString);
  });
});

// Function to add the target="_blank" attribute
function addTargetAttribute() {
  const downloadLinks = document.querySelectorAll('.youzify-media-download a');
  downloadLinks.forEach((link) => {
    if (!link.hasAttribute('target')) {
      link.setAttribute('target', '_blank');
    }
  });
}

// Observe only the specific container
const observerTarget = document.querySelector('.youzify-media-widget');

if (observerTarget) {
  const observer = new MutationObserver((mutationsList) => {
    mutationsList.forEach((mutation) => {
      if (mutation.type === 'childList') {
        // Ensure new nodes are processed
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE && node.matches('.youzify-media-group-files')) {
            addTargetAttribute(); // Run the function to set attributes
          }
        });
      }
    });
  });

  // Start observing the target node for child additions
  observer.observe(observerTarget, { childList: true, subtree: true });
}

// Fallback: Attach to document for cases where AJAX content may already exist
document.addEventListener('DOMContentLoaded', addTargetAttribute);

// Activity Registration Handler
$(document).ready(($) => {
  $(document).on('click', '.js-activity-registration', function (e) {
    e.preventDefault();
    const $button = $(this);
    const postId = $button.data('post-id');
    const currentAction = $button.data('action');
    const newAction = currentAction === 'register' ? 'unregister' : 'register';
    const $textSpan = $button.find('.registration-text');
    const currentText = $textSpan.text();

    // Determine activity type from button text or use generic text
    let registerText = 'Deelnemen';
    let unregisterText = 'Afmelden';

    if (currentText.includes('cursus')) {
      registerText = 'Deelnemen';
      unregisterText = 'Afmelden';
    } else if (currentText.includes('evenement')) {
      registerText = 'Deelnemen';
      unregisterText = 'Afmelden';
    }

    // Disable button during request
    $button.prop('disabled', true);

    ajax(
      'activity_registration',
      {
        post_id: postId,
        registration_action: currentAction,
      },
      (response) => {
        // Update button state
        $button.data('action', newAction);

        // Update button text
        if (newAction === 'register') {
          $textSpan.text(registerText);
        } else {
          $textSpan.text(unregisterText);
        }

        // Update registration count if available
        if (response.data && response.data.registration_count !== undefined) {
          const newCount = response.data.registration_count;
          const maxAttendants = $button.data('max-attendants') || $button.closest('[data-max-attendants]').data('max-attendants');

          // Update all registration count elements for this post
          $(`.js-registration-count[data-post-id="${postId}"]`).each(function () {
            const $countElement = $(this);
            const maxAtt = $countElement.data('max-attendants') || maxAttendants;

            if (maxAtt) {
              $countElement.text(`${newCount} / ${maxAtt}`);
            } else {
              $countElement.text(newCount);
            }
          });
        }

        // Show success message (optional)
        if (response.data && response.data.message) {
          // You can add a toast notification here if needed
          console.log(response.data.message);
        }

        $button.prop('disabled', false);
      },
      (error) => {
        // Show error message
        const errorMsg = error && error.data && error.data.message
          ? error.data.message
          : mainT('registration_request_error');
        alert(errorMsg);
        $button.prop('disabled', false);
      },
    );
  });

  // Load More Attendants Handler
  $(document).on('click', '.js-load-more-attendants', function (e) {
    e.preventDefault();
    const $button = $(this);
    const $container = $button.closest('.b-attendants');
    const $list = $container.find('.js-attendants-list');
    const postId = $container.data('post-id');
    const personsPerPage = $container.data('persons-per-page') || 3;
    const currentOffset = parseInt($button.data('offset')) || 0;

    // Disable button during request
    $button.prop('disabled', true);
    const originalText = $button.text();

    ajax(
      'load_more_attendants',
      {
        post_id: postId,
        offset: currentOffset,
        persons_per_page: personsPerPage,
      },
      (response) => {
        if (response.data && response.data.html) {
          // Append new attendants
          $list.append(response.data.html);

          // Update button
          const newOffset = currentOffset + (response.data.loaded || 0);
          const remaining = response.data.remaining || 0;

          if (remaining > 0) {
            $button.data('offset', newOffset);
            $button.text(`Laad meer (${remaining})`);
            $button.prop('disabled', false);
          } else {
            // No more attendants, hide button
            $button.closest('.text-center').remove();
          }
        } else {
          $button.prop('disabled', false);
        }
      },
      (error) => {
        const errorMsg = error && error.data && error.data.message
          ? error.data.message
          : mainT('load_attendants_error');
        alert(errorMsg);
        $button.prop('disabled', false);
        $button.text(originalText);
      },
    );
  });

  // Load More Linked Persons Handler
  $(document).on('click', '.js-load-more-linked-persons', function (e) {
    e.preventDefault();
    const $button = $(this);
    const $container = $button.closest('.t-organisation-single__top-left').find('.js-linked-persons-container');
    const organisationId = $container.data('organisation-id');
    const personsPerPage = $container.data('persons-per-page') || 8;
    const currentOffset = parseInt($button.data('offset')) || 0;

    // Disable button during request
    $button.prop('disabled', true);
    const originalHtml = $button.html();

    ajax(
      'load_more_linked_persons',
      {
        organisation_id: organisationId,
        offset: currentOffset,
        persons_per_page: personsPerPage,
      },
      (response) => {
        if (response.data && response.data.html) {
          // Append new persons before the load more button wrapper
          const $buttonWrapper = $button.closest('.js-load-more-linked-persons-wrapper');
          $buttonWrapper.before(response.data.html);

          // Update button
          const newOffset = currentOffset + (response.data.loaded || 0);
          const remaining = response.data.remaining || 0;

          if (remaining > 0) {
            $button.data('offset', newOffset);
            $button.prop('disabled', false);
          } else {
            // No more persons, hide button wrapper
            $buttonWrapper.remove();
          }
        } else {
          $button.prop('disabled', false);
        }
      },
      (error) => {
        const errorMsg = error && error.data && error.data.message
          ? error.data.message
          : mainT('load_persons_error');
        alert(errorMsg);
        $button.prop('disabled', false);
        $button.html(originalHtml);
      },
    );
  });
});
